import React from 'react';

const IOContext = React.createContext({
  isIntersecting: null,
  boundingClientRect: null
});

export const { Provider, Consumer } = IOContext;
